import { Exception } from '../Exception';

export class OutlookAttachmentsNotAvailableException extends Exception {
  constructor() {
    const message =
      "Attachments for digitally signed items can't be saved from Outlook for Windows (New or Classic) " +
      "and attachments for encrypted items can't be saved from Outlook for Windows (Classic) due to a long-standing Outlook bug. " +
      'You can try saving this item from Outlook on the Web instead.';

    super(message);
  }
}
